module.exports = __webpack_public_path__ + "static/img/qccode-bg.8ff4c511.png";